import { useEffect, useState } from "react";
import { settingsStore } from "../settings/store";

import ru from "./ru.json";
import en from "./en.json";
import kk from "./kk.json";

type Lang = "ru" | "en" | "kk";

const dict: Record<Lang, Record<string, string>> = {
  ru: ru as any,
  en: en as any,
  kk: kk as any
};

export function useT() {
  const [, force] = useState(0);

  useEffect(() => {
    const unsubscribe = settingsStore.subscribe(() => force((x) => x + 1));
    return () => {
      unsubscribe();
    };
  }, []);

  return (key: string) => {
    const s = settingsStore.get();
    const lang = (s.language || "ru") as Lang;
    return dict[lang]?.[key] ?? dict.ru[key] ?? key;
  };
}
